import './plugins/lazyload.js';
import initHeaderMenu from './parts/menu.js';
import anchorScrollInit from "./parts/anchorScroll";
import $ from 'jquery';

$(document).on('ready', function () {
    anchorScrollInit();
    initHeaderMenu();
});
